import memoize from 'memoize-one';
import startCase from 'lodash/startCase';
import { DateTime } from 'luxon';

import maskString from './maskString';

export const formatNumber = (numberOrNumberString: number | string): string => {
  let numberToFormat;
  if (typeof numberOrNumberString === 'string') {
    numberToFormat = Number(numberOrNumberString);
  } else {
    numberToFormat = numberOrNumberString;
  }

  return new Intl.NumberFormat().format(numberToFormat);
};

/**
 * Turns YYYY-MM-DD formatted date strings into MM/DD/YYYY date strings.
 */
export const formatDate = (dateString: string): string => {
  return DateTime.fromFormat(dateString, 'yyyy-MM-dd').toFormat('MM/dd/yyyy');
};

export const formatDollars = (numberOrNumberString: number | string): string => {
  let numberToFormat: number;
  if (typeof numberOrNumberString === 'string') {
    numberToFormat = Number(numberOrNumberString);
  } else {
    numberToFormat = numberOrNumberString;
  }

  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(
    numberToFormat,
  );
};

export const formatDob = memoize((dob: string): string => maskString(dob, '00/00/0000'));

export const formatPhone = memoize((phone: string): string => maskString(phone, '(000) 000-0000'));

export const formatTimezone = memoize((IANATimezone: string): string =>
  IANATimezone.split('/')
    .map(i => startCase(i))
    .join('/'),
);

export const formatTimezoneWithOffset = (tz: string): string | null => {
  try {
    const luxonTz = DateTime.utc().setZone(tz);
    const isInvalid = luxonTz.invalidReason;
    if (isInvalid) return null;

    // Offset format = (abbreviated named offset - short offset)
    // Example (PDT -7:00)
    const offset = luxonTz.toFormat('ZZZZ');

    // America/Los_Angeles => America - Los Angeles
    const name = tz.replace('/', ' - ').replace('_', ' ');
    return `${name} (${offset})`;
  } catch (err) {
    return null;
  }
};
